import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Vue from 'vue';
import VueGtag from 'vue-gtag';

/**
 * Note that this plugin is V1 and must remain in V1.
 * V2 is only compatible with Vue3.
 * @see [vue-gtagV1](https://matteo-gabriele.gitbook.io/vue-gtag/v/master/)
 */
export default (function (ctx, inject) {
  Vue.use(VueGtag, _objectSpread(_objectSpread({
    config: {
      id: process.env.isProduction ? 'G-E3CRSTVYMH' : 'G-G1QBZKPNB4'
    } /** Google Analytics 4 */
  }, process.env.isProduction && {
    includes: [{
      id: 'AW-10888375321'
    }] /** Google Ads */
  }), {}, {
    enabled: String(process.env.NUXT_ANALYTICAL_TRACKING) === 'true'
  }));
  // @ts-expect-error - Wrong type definition
  var gtag = Vue.$gtag;
  ctx.$gtag = gtag;
  inject('gtag', gtag);
});